import { FeedItem } from "./FeedItem";

export default FeedItem;
